import { Link } from "react-router-dom";
import { t } from "../constants/i18n";
import { useRemoteProjects, useRemoteProducts } from "../hooks/useRemoteData";
import type { Lang } from "../constants/i18n";
import "./Hero.css";

interface HeroProps {
  lang: Lang;
}

export default function Hero({ lang }: HeroProps) {
  const { data: PROJECTS } = useRemoteProjects();
  const { data: PRODUCTS } = useRemoteProducts();

  return (
    <section className="hero">
      <div className="container" style={{ width: "100%", position: "relative" }}>
        <div className="hero-content">
          <div className="hero-eyebrow fi fi-1">{t(lang, "hero_subtitle")}</div>
          <h1 className="hero-title fi fi-2">
            <span className="hero-the">The</span>
            <span className="hero-lab">Lab</span>
          </h1>
          <p className="hero-desc fi fi-3">{t(lang, "hero_desc")}</p>
          <Link className="hero-cta fi fi-4" to="/projects">
            {t(lang, "hero_cta")}
          </Link>
        </div>
        <div className="hero-stats">
          <div>
            <span className="hero-stat-num">{String(PROJECTS.length).padStart(2, "0")}</span>
            <span className="hero-stat-label">{t(lang, "nav_projects")}</span>
          </div>
          <div>
            <span className="hero-stat-num">{String(PRODUCTS.length).padStart(2, "0")}</span>
            <span className="hero-stat-label">{t(lang, "nav_products")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
